import { useQuery } from '@tanstack/react-query'
import { getBlackbookDetails } from '@core/Areas/Blackbook/helpers/api'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { useBlackbookPushAlertQuery } from '@core/Areas/Blackbook/Hooks/useBlackbookPushAlertQuery'
import { useBlackbookPushAlertMutation } from '@core/Areas/Blackbook/Hooks/useBlackbookPushAlertMutation'
import { useBlackbookSmsEmailAlertMutation } from '@core/Areas/Blackbook/Hooks/useBlackbookSmsEmailAlertMutation'

export const useBlackbookDetailsQuery = (accountNumber: number) => {
  const detailsQuery = useQuery({
    queryKey: [queryKeys.blackbookDetails],
    queryFn: getBlackbookDetails,
    retry: false,
    refetchOnWindowFocus: false,
  })

  const pushAlertQuery = useBlackbookPushAlertQuery(accountNumber)

  const { mutateAsync: mutatePushAlertAsync, isPending: isPushAlertMutating } =
    useBlackbookPushAlertMutation({
      accountNumber,
    })

  const { mutateAsync: mutateSmsEmailAlertAsync, isPending: isSmsEmailAlertMutating } =
    useBlackbookSmsEmailAlertMutation()

  return {
    detailsQuery,
    pushAlertQuery,
    mutatePushAlertAsync,
    mutateSmsEmailAlertAsync,
    isPushAlertMutating,
    isSmsEmailAlertMutating,
    isDetailsError: detailsQuery.isError,
    isPushAlertError: pushAlertQuery.isError,
    isError: detailsQuery.isError || pushAlertQuery.isError,
    isLoading: detailsQuery.isLoading,
  }
}
